import { render, staticRenderFns } from "./BlFormatSettings.vue?vue&type=template&id=c4e8e504&scoped=true&"
import script from "./BlFormatSettings.vue?vue&type=script&lang=js&"
export * from "./BlFormatSettings.vue?vue&type=script&lang=js&"
import style0 from "./BlFormatSettings.vue?vue&type=style&index=0&id=c4e8e504&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4e8e504",
  null
  
)

export default component.exports